import React, { Fragment, useEffect, useState } from "react";
import "../../css/animate.css";
import "../../css/bootstrap.css";
import "../../css/flaticon.css";
import "../../css/jquery.fancybox.css";
import "../../css/hover.css";
import "../../css/font-awesome.css";
import "../../css/owl.css";
import "../../css/responsive.css";
import "../../css/revolution-slider.css";
import { FaInstagram } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { IoStar } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { FaComments } from "react-icons/fa";
import "../../css/style.css";
import img5 from "../../skin Images/img5.jpeg";
import Desktop1 from "../../skin Images/Desktop1.jpg";
import Desktop2 from "../../skin Images/Desktop2.jpg";
import banner from "../../skin Images/banner.png";
import banner2 from "../../skin Images/banner2.png";
import banner3 from "../../skin Images/banner3.png";
import "./home.css";
import fluidimage2 from "../../images/resource/fluid-image-2.jpg";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import Faq from "../../Components/Layout/Faq";
import BestSellers from "../../Components/Layout/BestSellers";
import Brands from "../../Components/Layout/Brands";
import { Paper, Box, ButtonBase } from "@mui/material";
import { API_ENDPOINTS, BASE_URL } from "../../utils/api";
import { FaShareNodes } from "react-icons/fa6";
import { FaComment } from "react-icons/fa";
import "./home.css";
import { FaShareAlt } from "react-icons/fa";

const slidesData = [
  {
    backgroundImage: `url(${Desktop1})`,
  },
  {
    backgroundImage: `url(${Desktop2})`,
  },
];

const Home = ({ data }) => {
  const [categories, setCategories] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [bannerStyle, setBannerStyle] = useState({ height: "15vh" });
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
      if (window.innerWidth < 750) {
        setBannerStyle({ height: "15vh" });
      } else {
        setBannerStyle({ height: "50vh" });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(
        (prevActiveSlide) => (prevActiveSlide + 1) % slidesData.length
      );
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    async function getCategory() {
      try {
        const response = await axios.get(
          `${BASE_URL}${API_ENDPOINTS.getCategories}`
        );
        setCategories(response.data.result);
      } catch (error) {
        console.log("Fetching data is not successful", error);
      }
    }
    getCategory();
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <section className="main-slider revolution-slider">
          <div className="tp-banner-container">
            <div className="tp-banner">
              <ul>
                <li
                  data-transition="fade"
                  data-slotamount={1}
                  data-masterspeed={1000}
                  data-thumb="images/main-slider/1.jpg"
                  data-saveperformance="off"
                  data-title="Awesome Title Here"
                >
                  <div className="section1Div">
                    <Box
                      position="relative"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      {slidesData.map((slide, index) => (
                        <Box
                          key={index}
                          component={Paper}
                          className="banner-images-top"
                          style={{
                            display: activeSlide === index ? "block" : "none",
                            backgroundImage: slide.backgroundImage,
                            backgroundSize: "contain",
                            ...bannerStyle,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                          }}
                        ></Box>
                      ))}
                      <Box position="absolute" bottom={0} right={0}>
                        {slidesData.map((_, index) => (
                          <ButtonBase
                            key={index}
                            onClick={() => setActiveSlide(index)}
                            style={{
                              margin: 4,
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor:
                                activeSlide === index ? "blue" : "grey",
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Shop By Categories Section */}
        <section
          style={{
            padding: "40px 20px",
            backgroundColor: "#f9f9f9",
            margin: "0 auto",
            maxWidth: "1400px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2
              style={{
                color: "rgba(111, 135, 81, 1)",
                fontSize: "32px",
                fontWeight: "600",
                margin: "0",
              }}
            >
              Shop By Categories
            </h2>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: "20px",
              padding: "0 10px",
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            {categories.map(({ categoryName, _id, imgData }) => (
              <div
                key={_id}
                style={{
                  width: isDesktop ? "calc(25% - 15px)" : "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s ease",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 0,
                      paddingBottom: "100%", // Square aspect ratio to show full image
                    }}
                  >
                    <NavLink to={`/${categoryName}/${_id}`}>
                      <img
                        src={imgData}
                        alt={categoryName}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // Changed to contain to show full image
                          opacity: 1,
                          transition: "opacity 0.3s ease",
                        }}
                      />
                    </NavLink>
                  </div>
                  <div style={{ padding: "15px", textAlign: "center" }}>
                    <h3 style={{ margin: "0", fontSize: "18px", fontWeight: "500" }}>
                      <NavLink
                        to={`/${categoryName}/${_id}`}
                        style={{
                          color: "#333",
                          textDecoration: "none",
                          ":hover": {
                            color: "rgba(111, 135, 81, 1)",
                          },
                        }}
                      >
                        {categoryName}
                      </NavLink>
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <BestSellers data={data} />
        <Brands data={data} />
        <Faq />
        <div>
          <div className="rewards-title">
            <h1>Welcome to Noura Rewards</h1>
          </div>
          <div className="rewards-description">
            <h4>
              <span>Get </span> <span>coupons </span>of <span>Noura </span>skincare. Here's how.
            </h4>
          </div>
        </div>

        <div className="points-container">
          <div className="points-box signup-box">
            <div className="points-inner">
              <div className="points-icon"><FaInstagram size="40px" /></div>
              <p className="points-description">Follow our Instagram page @nourakoreanskincare.</p>
            </div>
          </div>
          <div className="points-box purchase-box">
            <div className="points-inner">
              <div className="points-icon"><FaShareAlt size="40px" /></div>
              <p className="points-description">Share any instagram post to your story.</p>
            </div>
          </div>
          <div className="points-box review-box">
            <div className="points-inner">
              <div className="points-icon"><FaComments size="40px" /></div>
              <p className="points-description">Comment and tag 3 friends</p>
            </div>
          </div>
        </div>

        <div
          style={{
            fontWeight: "bold",
            fontSize: "1.6rem",
            marginLeft: "100px",
            width: "50%",
            margin: "10px auto",
            alignItems: "center",
          }}
        >
          <div>1.Follow steps & send screenshot in Instagram or what's app</div>
          <div>
            2.Get coupons of Noura skincare goodies and indulge in the ultimate self-care experience.
            Don't miss out.
          </div>
        </div>
      </div>
      <div
        className="scroll-to-top scroll-to-target"
        data-target=".main-header"
      >
        <span className="fa fa-long-arrow-up" />
      </div>
    </div>
  );
};

export default Home;